// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Icon from "@mui/material/Icon";

// React Router
import { useNavigate } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Setup menu items
const setupMenus = [
  {
    title: "Payment Items",
    description: "Manage Payment Items",
    icon: "people",
    route: "/setup/pay-items",
  },
  // {
  //   title: "Grade Level",
  //   description: "Manage Grade Level",
  //   icon: "verified_user",
  //   route: "/setup/grade-levels",
  // },
  {
    title: "Cadres",
    description: "Manage Cadres",
    icon: "lock",
    route: "/setup/cadres",
  },
  {
    title: "Designations",
    description: "Manage Designations",
    icon: "lock",
    route: "/setup/designations",
  },
  {
    title: "Salary Structures",
    description: "Manage Salary Structures",
    icon: "lock",
    route: "/setup/salary-structures",
  },
  {
    title: "Staff Group",
    description: "Manage Staff Groups",
    icon: "lock",
    route: "/setup/staff-group",
  },
  {
    title: "Staff Categories",
    description: "Manage Staff Categories",
    icon: "lock",
    route: "/setup/staffCategories",
  },
  {
    title: "Non-Regular Earnings",
    description: "Manage Non-Regular Earnings",
    icon: "lock",
    route: "/setup/nonregularearnings",
  },
  {
    title: "Arrears Upload",
    description: "Manage Arrears Upload",
    icon: "lock",
    route: "/setup/arrearsupload",
  },
  {
    title: "Irregular Allowances",
    description: "Manage Irregular Allowances",
    icon: "lock",
    route: "/setup/irregularallowances",
  },

  {
    title: "Mapped Salary Structure",
    description: "Manage Mapped Salary Structure",
    icon: "lock",
    route: "/setup/map-salary-structure",
  },
  {
    title: "Designation Details",
    description: "View Designation Details",
    icon: "lock",
    route: "/setup/designation/details",
  },
  {
    title: "Cadre Details",
    description: "View Cadre Details",
    icon: "lock",
    route: "/setup/cadre/details",
  },
  {
    title: "Staff Payment Details",
    description: "Display Staff Payment Details",
    icon: "money",
    route: "/setup/staffdetails",
  },
  {
    title: "Earnings Details",
    description: "Display Earnings Details",
    icon: "money",
    route: "/setup/earnings",
  },
  {
    title: "Deductions Details",
    description: "Display Deductions Details",
    icon: "money",
    route: "/setup/deductions",
  },
  // {
  //   title: "Departments",
  //   description: "Manage departments",
  //   icon: "apartment",
  //   route: "/setup/departments",
  // },
  // {
  //   title: "Locations",
  //   description: "Configure locations",
  //   icon: "place",
  //   route: "/setup/locations",
  // },
  // {
  //   title: "Audit Logs",
  //   description: "Track activity logs",
  //   icon: "history",
  //   route: "/setup/audit-logs",
  // },
  // {
  //   title: "Notifications",
  //   description: "Notification templates",
  //   icon: "notifications",
  //   route: "/setup/notifications",
  // },
];

function SetupMenu() {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          {setupMenus.map((item, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card sx={{ minHeight: 150, transition: "0.3s", "&:hover": { boxShadow: 6 } }}>
                <CardActionArea onClick={() => navigate(item.route)}>
                  <CardContent>
                    <MDBox display="flex" alignItems="center" mb={1}>
                      <Icon sx={{ fontSize: 30, color: "primary.main", mr: 1 }}>{item.icon}</Icon>
                      <Typography variant="h6">{item.title}</Typography>
                    </MDBox>
                    <Typography variant="body2" color="text.secondary">
                      {item.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default SetupMenu;
